import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { AssessmentOverviewQuestionnaireItem } from './questionnaire'

// Assessment overview section questionnaire answer type mapping
export const ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME]:
    QuestionnaireAnswerType.GROUP,
  [AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START]:
    QuestionnaireAnswerType.DATE_TIME,
  [AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END]:
    QuestionnaireAnswerType.DATE_TIME
}
